"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertsDetail = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const lodash_1 = require("lodash");
const react_intl_1 = require("react-intl");
const reactstrap_1 = require("reactstrap");
const ReactReduxRequest_1 = require("../ReactReduxRequest");
const AlertsProgress_1 = require("./AlertsProgress");
const Messages_1 = __importDefault(require("./Messages"));
const Redux_1 = require("./Redux");
const AlertMessage = (props) => {
    const messages = props.messages.length > 0 &&
        props.messages[0].messages
        ? (0, ReactReduxRequest_1.getStrapiErrorMessages)(props.messages)
        : props.messages;
    if (!messages) {
        return (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { ...Messages_1.default.somethingWrong }, void 0);
    }
    return ((0, jsx_runtime_1.jsx)("ul", { children: messages.map((message, index) => ((0, jsx_runtime_1.jsx)("li", { children: message.message }, `error_message_${props.id}_${index}`))) }, void 0));
};
const AlertsDetail = ({ alert, dispatch, }) => {
    const isOpen = alert.state && alert.state === Redux_1.ToggleType.Show ? true : false;
    const intl = (0, react_intl_1.useIntl)();
    const onDismiss = () => {
        if (alert.state && alert.state === Redux_1.ToggleType.Show) {
            dispatch(Redux_1.alertAction.hide({
                id: alert.id,
                message: alert.message,
                type: alert.type,
            }));
            setTimeout(() => dispatch(Redux_1.alertAction.remove({
                id: alert.id,
                message: alert.message,
                type: alert.type,
            })), 3000);
        }
    };
    return ((0, jsx_runtime_1.jsx)(reactstrap_1.Fade, { in: isOpen, children: (0, jsx_runtime_1.jsxs)(reactstrap_1.Alert, { color: alert.type, toggle: onDismiss, children: [(0, jsx_runtime_1.jsx)(AlertsProgress_1.AlertsProgress, { done: onDismiss, type: alert.type }, void 0), !(0, lodash_1.isArray)(alert.message) ? (alert.message || intl.formatMessage({ ...Messages_1.default.somethingWrong })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(AlertMessage, { id: alert.id, messages: alert.message }, void 0) }, void 0))] }, void 0) }, void 0));
};
exports.AlertsDetail = AlertsDetail;
exports.default = exports.AlertsDetail;
